import { Location } from "history";
import * as React from "react";
import { matchPath, useLocation } from "react-router-dom";

import matchEndOfPath from "./matchEndOfPath";

type Props = {
  children: React.ReactElement;
  pathsEndingWith: string[] | string;
  onlyRenderForPathsStartingWith?: string[];
  // used to define the pages the journey is allowed to open over
  location?: Location;
};

export default function PathEndsWithRoute({
  children,
  pathsEndingWith,
  onlyRenderForPathsStartingWith,
  location: _location
}: Props) {
  const hookLocation = useLocation();
  const location = _location || hookLocation;

  const allowedToOpenOverCurrentLocation = onlyRenderForPathsStartingWith
    ? onlyRenderForPathsStartingWith.some(
        link =>
          !!matchPath(location.pathname, {
            path: link,
            exact: false
          })
      )
    : true;

  if (!allowedToOpenOverCurrentLocation) {
    return null;
  }

  const _pathsEndingWith = Array.isArray(pathsEndingWith)
    ? pathsEndingWith
    : [pathsEndingWith];

  const currentLocationIsInJourney = _pathsEndingWith.some(
    link =>
      !!matchEndOfPath(location.pathname, {
        path: link,
        exact: false
      })
  );

  if (!currentLocationIsInJourney) {
    return null;
  }

  return children;
}
